import React from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogProps,
    Grid,
    InternalStandardProps,
    Box,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppTypography } from "JS/React/Components/AppTypography";

const StyledDialog = styled(Dialog)({
    "& .MuiDialog-scrollPaper": {
        alignItems: "flex-start",
    },
    "& .MuiDialog-paperScrollBody": {
        verticalAlign: "top",
    },
});

const StyledDialogWrapper = styled(Box)(({ theme }) => ({
    minHeight: "30vh",
    backgroundColor: theme.palette.background.default,
    color: theme.palette.common.black,
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    color: theme.palette.common.black,
}));

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
    color: theme.palette.common.black,
}));

const StyledFilterIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    fontSize: "22px",
    cursor: "pointer",
    color: theme.palette.grey[600],
}));

const StyledDialogHeaderTxt = styled(AppTypography)(({ theme }) => ({
    color: theme.palette.grey[600],
}));

export const GiftDashboardFiltersDialog = (props: AppFiltersDialogProps) => {
    const {
        className,
        onClose,
        showTitle = true,
        titleText,
        children,
        open,
        ...rest
    } = props;

    return (
        <StyledDialog
            role="dialog"
            aria-modal="true"
            maxWidth={"sm"}
            fullWidth
            className={className}
            scroll="paper"
            open={open}
            {...rest}
        >
            <StyledDialogWrapper className={className}>
                {showTitle && (
                    <StyledDialogTitle>
                        <Grid container>
                            <Grid
                                item
                                xs={12}
                                display={"flex"}
                                justifyContent={"space-between"}
                                alignItems={"center"}
                            >
                                <StyledDialogHeaderTxt
                                    variant="h6"
                                    aria-label={titleText}
                                >
                                    {titleText}
                                </StyledDialogHeaderTxt>
                                <StyledFilterIcon
                                    icon={["fas", "xmark"]}
                                    onClick={onClose}
                                />
                            </Grid>
                        </Grid>
                    </StyledDialogTitle>
                )}
                <StyledDialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            {children}
                        </Grid>
                    </Grid>
                </StyledDialogContent>
            </StyledDialogWrapper>
        </StyledDialog>
    );
};

export interface AppFiltersDialogProps
    extends InternalStandardProps<DialogProps> {
    onClose: () => void;
    showTitle?: boolean;
    titleText?: string;
    children: React.ReactNode;
}
